module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticStyle: {
      "width": "400px",
      "margin": "auto"
    },
    attrs: {
      "title": _vm.title,
      "visible": _vm.dialogFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      },
      "close": _vm.close
    }
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "90px",
      "element-loading-text": _vm.elementLoadingText
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "el-form-item is-required"
  }, [_c('label', {
    staticClass: "el-form-item__label",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "for": "mobile"
    }
  }, [_vm._v("回寄物流：")]), _vm._v(" "), _c('div', {
    staticClass: "el-form-item__content",
    staticStyle: {
      "margin-left": "100px"
    }
  }, [_c('div', {
    staticClass: "el-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.logistics),
      expression: "form.logistics"
    }],
    staticClass: "el-input__inner",
    attrs: {
      "type": "text",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.form.logistics)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "logistics", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "el-form-item is-required"
  }, [_c('label', {
    staticClass: "el-form-item__label",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "for": "mobile"
    }
  }, [_vm._v("回寄单号：")]), _vm._v(" "), _c('div', {
    staticClass: "el-form-item__content",
    staticStyle: {
      "margin-left": "100px"
    }
  }, [_c('div', {
    staticClass: "el-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.logisticsNo),
      expression: "form.logisticsNo"
    }],
    staticClass: "el-input__inner",
    attrs: {
      "type": "text",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.form.logisticsNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "logisticsNo", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "el-form-item"
  }, [_c('label', {
    staticClass: "el-form-item__label",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "for": "mobile"
    }
  }, [_vm._v("寄回地址：")]), _vm._v(" "), _c('div', {
    staticClass: "el-form-item__content",
    staticStyle: {
      "margin-left": "100px"
    }
  }, [_c('div', {
    staticClass: "el-input",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.returnAddress.name) + "  " + _vm._s(_vm.returnAddress.mobile) + "  " + _vm._s(_vm.returnAddress.province) + "  " + _vm._s(_vm.returnAddress.city) + "  " + _vm._s(_vm.returnAddress.area) + " " + _vm._s(_vm.returnAddress.address) + " \n              ")])])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "closeBtn",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    staticClass: "saveBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.validateData
    }
  }, [_vm._v("确 定")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f29942e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/components/SendBack.vue
// module id = 753
// module chunks = 2